$shm_service_mode_controls $mol_view
	edit_title \Редактирование
	view_title \Просмотр
	edit? null
	view? null
	view_enabled false
	edit_color \
	view_color \
	sub /
		<= Edit $mol_button_minor
			title <= edit_title
			click? <=> edit? null
			style *
				^
				color <= edit_color
		<= View $mol_button_minor
			title <= view_title
			enabled <= view_enabled
			click? <=> view? null
			style *
				^
				color <= view_color
